const Categories = [
    {
        name: "Vocabulary",
        icon: "writing",
        options: [
            {
                name: 'Read And Select (new)',
                value: 'Rsn'
            },

        ]
    },

    {
        name: "Writing",
        icon: "writing",
        options: [
            {
                name: 'Write About Photo',
                value: 'Wap'
            }, {
                name: 'Interactive Writing',
                value: 'Iw'
            },
            // {
            //     name: "Read Then Write",
            //     value: "Rtw"
            // },
            {
                name: "Writing Sample",
                value: "Ws"
            }
        ]
    },

    {
        name: "Reading",
        icon: "reading",
        options: [
            // {
            //     name: 'Read And Select',
            //     value: 'Rs'
            // },
            {
                name: 'Fill In The Blanks',
                value: 'Fib'
            },
            {
                name: 'Read And Complete',
                value: 'Rc'
            },
            {
                name: "Complete The Sentences",
                value: "Cs"
            }, {
                name: "Complete The Passage",
                value: "Cp"
            }, {
                name: "Highlight the Answer",
                value: "Ha"
            }, {
                name: "Identify The Idea",
                value: "Ii"
            }, {
                name: "Title The Passage",
                value: "Tp"
            }

        ]
    },

    {
        name: "Speaking",
        icon: "speaking",
        options: [
            // {
            //     "name": "Read Aloud",
            //     "value": "Ra"
            // },
            {
                name: "Speak About Photo",
                value: "Sap"
            },
            {
                name: "Read Then Speak",
                value: "Rts"
            },
            // {
            //     name: "Listen Then Speak",
            //     value: "Lts"
            // },
            {
                name: "Speaking Sample",
                value: "Ss"
            },
            {
                name: "Interactive Speaking",
                value: "Is"
            }
        ]
    },
    {
        name: "Listening",
        icon: "listening",
        options: [
            {
                name: "Listen And Type",
                value: "Lt"
            }, {
                name: "Listen And Respond",
                value: "Lr"
            }, {
                name: "Summarize The Conversation",
                value: "Sc"
            }, {
                name: "Interactive Listening",
                value: "Il"
            }
        ]
    }
]


export default Categories